jQuery($ => {
    class CheckboxDropdown {
      constructor(element) {
        this._            = element;
        this._element     = $(element);
        this._trigger     = this._element.find('.m-dropdown__trigger');
        this._triggerText = this._trigger.find('.m-dropdown__text');
        this._content     = this._element.find('.m-dropdown__content');
        this._checkbox    = this._content.find('.m-checkboxes__checkbox .a-checkbox__input');
        this._apply       = this._element.find('.m-checkbox-dropdown__apply');
        this._count       = this._element.find('.m-checkbox-dropdown__count');

        this._details = {
          target    : this,
          checkboxes: this._checkbox.filter(':checked'),
          value     : this._checkbox.filter(':checked').map((i, el) => el.value).get()
        };
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on('open', this.handleOpen);
        this._trigger.on('keydown', this.handleTriggerKeydown);
        this._checkbox.on('change', this.handleChange);
        this._checkbox.on('keydown', this.handleCheckboxKeydown);
        this._apply.on('keydown', this.handleApplyKeydown);
        this._apply.on('mousedown', this.handleApplyMousedown);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Trigger
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateTrigger = () => {
        const text       = this._trigger.attr('data-text');
        const checked    = this._checkbox.filter(':checked');
        const checkCount = checked.length;
        const title      = checked.map((i, el) => $(el).closest('.m-checkboxes__checkbox').find('.a-checkbox__label').text()).get().join(', ');

        this._trigger.attr('title', title);

        if (checkCount) {
          this._triggerText.text(`${text} (${checkCount})`);
        } else {
          this._triggerText.text(text);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Details
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateDetails = () => {
        this._details = {
          target    : this,
          checkboxes: this._checkbox.filter(':checked'),
          value     : this._checkbox.filter(':checked').map((i, el) => el.value).get()
        };
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reset
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReset = () => {
        this._checkbox.prop('checked', false);
        this.updateDetails();
        this.updateTrigger();
        // this._element.trigger('change', this._details);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Change
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleChange = () => {
        this.updateDetails();
        this.updateTrigger();
        // this._element.trigger('change', this._details);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Open
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOpen = () => {
        this._checkbox[0].focus();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Trigger Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleTriggerKeydown = event => {
        switch (event.key) {
          case "Escape":
          case "Esc":
          case "Delete":
          case "Backspace":
            event.preventDefault();
            this.handleReset();
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Checkbox Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleCheckboxKeydown = event => {
        switch (event.key) {
          case "Escape":
          case "Esc":
          case "Tab":
            event.preventDefault();
            this._element.dropdown('handleClose');
            break;

          case "ArrowUp":
            event.preventDefault();
            const $prevCheckbox = $(event.target).closest('.m-checkboxes__checkbox').prev();

            if ($prevCheckbox[0]) {
              $prevCheckbox.find(".a-checkbox__input").focus();
            } else {
              this._apply.focus();
            }
            break;

          case "ArrowDown":
            event.preventDefault();
            const $nextCheckbox = $(event.target).closest('.m-checkboxes__checkbox').next();

            if ($nextCheckbox[0]) {
              $nextCheckbox.find(".a-checkbox__input").focus();
            } else {
              this._apply.focus();
            }
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Apply
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleApply = () => {
        this._element.dropdown('handleClose');
        this._element.trigger('apply', this._details);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Apply Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleApplyKeydown = event => {
        const $firstCheckbox = this._checkbox.first();
        const $lastCheckbox  = this._checkbox.last();

        switch (event.key) {
          case "Enter":
            event.preventDefault();
            this.handleApply();

          case "ArrowUp":
            event.preventDefault();
            $lastCheckbox.focus();
            break;
            
          case "ArrowDown":
            event.preventDefault();
            $firstCheckbox.focus();
            break;
            
          case "Escape":
          case "Esc":
          case "Tab":
            event.preventDefault();
            this._element.dropdown('handleClose');
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Apply Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleApplyMousedown = event => {
        if (this._apply[0].type === 'button') {
          event.preventDefault();
          this.handleApply();
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.checkbox_dropdown = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].checkbox_dropdown = new CheckboxDropdown(_[i], opt);
        else
          ret = _[i].checkbox_dropdown[opt].apply(_[i].checkbox_dropdown, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-checkbox-dropdown').checkbox_dropdown();
});